import service from "@/utils/service"

//获取询盘列表,无参数时查询所有
export function getInquiryList(data) {
  return service({
    url: "/inquiry/info/view",
    method: "post",
    data: data
  })
}

//添加询盘
export function createInquiry(data) {
  return service({
    url: "/inquiry/info/add",
    method: "post",
    data: data
  })
}

//删除询盘信息
export function deleteInquiry(data) {
  return service({
    url: "/inquiry/info/del",
    method: "post",
    data: data
  })
}

//由于是统计留言板信息，因此逻辑上是不可以编辑的

//审核信息
export function reviewInquiry(Inquirydata, selectedId) {
  return service({
    url: "/inquiry/info/review",
    method: "post",
    data: { Inquirydata, selectedId }
  })
}

//获取上一篇下一篇
export function getNeighbourById(id) {
  return service({
    url: "/inquiry/info/neighbour",
    method: "post",
    data: id
  })
}

//添加询盘的时候，有一个所属人需要从后台获取[xp_user表]
export function getOwnerOptions() {
  return service({
    url: "/inquiry/info/getowneroptions",
    method: "get"
  })
}
